'use client';

import Script from 'next/script';

export const ZohoChat = () => {
  return (
    <>
      <Script
        id="zoho-salesiq-init"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            var $zoho = $zoho || {};
            $zoho.salesiq = $zoho.salesiq || {
              widgetcode: "53bb1c5e8ef732a0cf6b012048891c736858ee622e156415299c993aad3fcd04",
              values: {},
              ready: function () {
                console.log('[Zoho] ready');
              }
            };
          `,
        }}
      />

      <Script
        id="zoho-salesiq-widget"
        strategy="afterInteractive"
        src="https://salesiq.zoho.com/widget"
        onLoad={() => {
          console.log('[Zoho] script loaded');
          window.$zoho?.salesiq?.floatbutton?.visible?.('hide');
        }}
      />
    </>
  );
};
